'use client';

import { useMemo } from 'react';

export const useUrlQuery = (query: string) => {
  const search = window.location.search;

  const memo = useMemo(() => new URLSearchParams(search), [search]);

  return memo.get(query);
};
